<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="8">
          <CCardGroup>
            <CCard class="p-4">
              <div class="d-flex justify-content-center sidebar-bar-logo-bg">
                <CIcon
                  class="c-sidebar-brand-full "
                  name="logo"
                  size="custom-size"
                  :height="200"
                />
              </div>
              <CCardBody class="position-relative">
                <CForm>
                  <h1 class="mb-4">Kierros "{{ pageName }}" on maksullinen</h1>
                  <div
                    v-show="LoginError"
                    class="alert alert-danger"
                    role="alert"
                  >
                    {{ ErrorMessage }}
                  </div>
                  <CInput
                    placeholder="Syötä koodi tähän ja paina 'Kirjaudu'"
                    v-model="code"
                    v-on:keyup.enter="Login"
                    :disabled="Loading"
                    class="mb-4"
                  >
                  </CInput>
                  <CRow>
                    <CCol col="6" class="text-left">
                      <CButton
                        color="dark"
                        class="px-4"
                        @click="Login"
                        :disabled="Loading"
                        ><CSpinner
                          v-show="Loading"
                          color="secondary"
                          size="sm"
                          class="mr-2"
                        /><span>{{ loadingText }}</span></CButton
                      >
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import api from "@/utils/api";
export default {
  name: "SyotaKoodi",
  data() {
    return {
      code: null,
      pageId: null,
      pageName: "",
      h: "",
      cn: null,
      redirect_uri: "",
      LoginError: false,
      ErrorMessage: null,
      Loading: false,
      loadingText: "Kirjaudu",
      ErrorMessages: {
        code_used:
          "Koodi on jo käytetty. Ota yhteys Upseerikerhon henkilökuntaan. Puh. 044 333 1221",
        code_invalid:
          "Virheellinen koodi. Ota yhteys Upseerikerhon henkilökuntaan. Puh. 044 333 1221",
        code_saving_failed: "Koodin käyttöönotto epäonnistui. Yritä uudelleen."
      }
    };
  },
  methods: {
    createCookie: function(name, value) {
      let days = 1;
      let d = new Date();
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
      let expires = "; expires=" + d.toGMTString();
      document.cookie = name + "=" + value + expires + "; path=/";
    },
    Login: async function() {
      try {
        if (this.code && this.pageId && this.cn) {
          this.LoginError = false;
          this.Loading = true;
          this.loadingText = "Tarkistetaan koodia";
          this.ErrorMessage = null;
          this.redirecting = false;

          let codeStatus = await api.post(
            process.env.VUE_APP_UPSEERIKERHO_API_URL + "/code",
            {
              pageId: parseInt(this.pageId),
              code: this.code,
              h: this.h
            }
          );

          if (codeStatus.indexOf("success") === -1) {
            this.LoginError = true;
            this.ErrorMessage = this.ErrorMessages[codeStatus];
            this.Loading = false;
            this.loadingText = "Kirjaudu";
            return;
          }

          this.loadingText = "Ohjataan takaisin kierrokselle";

          this.createCookie(this.cn, this.code);
          this.ErrorMessage = null;
          this.code = null;
          this.pageId = null;

          let baseUrl =
            process.env.VUE_APP_MODE === "development"
              ? "http://localhost:8888"
              : "https://visithennala.fi";
          window.location.href =
            baseUrl + decodeURIComponent(this.redirect_uri);
        }
      } catch (e) {
        console.log(e);
      }
    }
  },
  async mounted() {
    this.pageId =
      this.$route &&
      "query" in this.$route &&
      "pageId" in this.$route.query &&
      !isNaN(this.$route.query.pageId)
        ? this.$route.query.pageId
        : null;
    this.pageName =
      this.$route &&
      "query" in this.$route &&
      "pageName" in this.$route.query &&
      this.$route.query.pageName !== ""
        ? this.$route.query.pageName
        : "";
    this.redirect_uri =
      this.$route &&
      "query" in this.$route &&
      "redirect_uri" in this.$route.query &&
      this.$route.query.redirect_uri !== ""
        ? this.$route.query.redirect_uri
        : "";
    this.h =
      this.$route &&
      "query" in this.$route &&
      "h" in this.$route.query &&
      this.$route.query.h !== ""
        ? this.$route.query.h
        : "";
    this.code =
      this.$route &&
      "query" in this.$route &&
      "code" in this.$route.query &&
      this.$route.query.code !== ""
        ? this.$route.query.code
        : null;
    this.cn =
      this.$route &&
      "query" in this.$route &&
      "cn" in this.$route.query &&
      this.$route.query.cn !== ""
        ? decodeURIComponent(this.$route.query.cn)
        : "";

    if (
      this.pageId === null ||
      this.pageName === "" ||
      this.redirect_uri === "" ||
      this.h === "" ||
      this.cn === ""
    ) {
      window.location.href = "https://visithennala.fi";
      return;
    }
    if (this.code !== "") {
      await this.Login();
    }
  }
};
</script>
